import OnScreen from 'onscreen';

export default {
    init() {
        const os = new OnScreen();
        os.on('enter', '.add_fadeInUp ', (element) => {
            if (element.classList.contains('add_fadeInUp') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInUp');
                element.className += ' fadeInUp  show';
            }
        });
        os.on('enter', '.add_fadeInDown ', (element) => {
            if (element.classList.contains('add_fadeInDown') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInDown');
                element.className += ' fadeInDown  show';
            }
        });
        os.on('enter', '.add_fadeInRight ', (element) => {
            if (element.classList.contains('add_fadeInRight') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInRight');
                element.className += ' fadeInRight  show';
            }
        });

        os.on('enter', '.add_fadeInLeft ', (element) => {
            if (element.classList.contains('add_fadeInLeft') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInLeft');
                element.className += ' fadeInLeft  show';
            }
        });
        os.on('enter', '.home__work ', () => {
            Array.prototype.forEach.call(document.getElementsByClassName('home__dots'), function (element) {
                if (!element.classList.contains('home__dots--active')) {
                    element.className += ' home__dots--active';
                }
            });
        });

        $('.js-positions__testimonials__others__links__box ').on('click',function () {
            if(!$(this).hasClass('positions__testimonials__others__links__box--selected')){
                $('.positions__testimonials__others__links__box--selected').removeClass('positions__testimonials__others__links__box--selected');
                $('.positions__testimonials__testimonial__image--selected').removeClass('positions__testimonials__testimonial__image--selected');
                $('.positions__testimonials__testimonial__item--selected').removeClass('positions__testimonials__testimonial__item--selected');

                var id = $(this).data('id');
                $(this).addClass('positions__testimonials__others__links__box--selected');
                $('#positions__testimonials__testimonial__image__'+id).addClass('slideInRight');
                $('#positions__testimonials__testimonial__item__'+id).addClass('fadeIn');
                $('#positions__testimonials__testimonial__image__'+id).addClass('positions__testimonials__testimonial__image--selected');
                $('#positions__testimonials__testimonial__item__'+id).addClass('positions__testimonials__testimonial__item--selected');
            }

        });

        post_height('.js-services__box__item__text');
        post_height('.positions__testimonials__testimonial__item');


    },
    finalize() {
        const os = new OnScreen();
        // JavaScript to be fired on the home page, after the init JS
        os.on('enter', '.js-lines', (element) => {
            if (element.classList.contains('js-lines-init') && ($.screenwidth() >= 990)) {
                element.classList.remove('js-lines-init');
                element.className += ' js-lines-active';
            }
        });
        os.on('leave', '.js-lines', (element) => {
            if (element.classList.contains('js-lines-active') && ($.screenwidth() >= 990)) {
                element.classList.remove('js-lines-active');
                element.className += ' js-lines-init';
            }
        });
    },
};

function post_height($element) {
    $($element).removeAttr('style');
    setTimeout(function () {
        var maxheight = 0;
        $($element).each(function () {
            if ($(this).height() > maxheight) {
                maxheight = $(this).outerHeight();
            }
        });

        $($element).css('min-height', maxheight + 'px');
    }, 200);
}



// WEBPACK FOOTER //
// ./scripts/routes/jobs.js